"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareMappingPath = void 0;
exports.default = {
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    PINTEREST: 'pinterest',
    TUMBLR: 'tumblr',
    LINK: 'link',
};
exports.shareMappingPath = '_api/media-share-server-for-video';
//# sourceMappingURL=social-networks.js.map